import { memo, ReactNode, useState } from "react";
import { Event, EventType } from "@markit/common.types";
import MediaPlayer from "../CreatorDashboard/Products/Components/MediaPlayer";
import PDFViewer from "../CreatorDashboard/Products/Components/PDFViewer";
import MediaPreviewCarousel from "../Media/MediaPreviewCarousel";

type ConfirmationProductMediaProps = {
  product: Event;
  creatorName: string;
  locked: boolean; // Blurs the media and shows lockedContent below it
  lockedContent?: ReactNode; // How the viewer unlocks it (sign in, enter phone number)
};

/**
 * The product's actual media (video, audio, pdf) as shown on FullProduct,
 * for the order details on the confirmation page
 */
const ConfirmationProductMedia = memo(function ConfirmationProductMediaFn(
  props: ConfirmationProductMediaProps
) {
  const { product, creatorName, locked, lockedContent } = props;
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);

  return (
    <div className="ColumnNormal" style={{ gap: 14, alignItems: "center" }}>
      {product.eventType === EventType.PDF ? (
        <PDFViewer productData={product} blurring={locked} />
      ) : (
        <MediaPlayer
          productData={product}
          blurring={locked}
          selectedMediaIndex={selectedMediaIndex}
          setSelectedMediaIndex={setSelectedMediaIndex}
          creatorName={creatorName}
          allowAutoplay={false}
          hardTheme={product.theme}
          renderMediaPreviewCarousel={
            <MediaPreviewCarousel
              event={product}
              hardTheme={product.theme}
              onSelectMedia={setSelectedMediaIndex}
            />
          }
        />
      )}
      {locked ? lockedContent : null}
    </div>
  );
});

export default ConfirmationProductMedia;
